module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.d0884059.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Medium.ttf
// module id = 868
// module chunks = 0